import { z } from 'zod';
import type {
  InboundReceiptCanceledEventPayload,
  InboundReceiptComparisonReviewedEventPayload,
  InboundReceiptConfirmedEventPayload,
  InboundReceiptInventoryPostedEventPayload,
  InboundReceiptInventoryPostingReversedEventPayload,
  InboundReceiptOfficialStateReplacedEventPayload,
} from './inbound-receipts-sync.dto.js';
import {
  InboundReceiptDetailDtoSchema,
  InboundReceiptOfficialComparisonDtoSchema,
  InboundReceiptOfficialSettlementDtoSchema,
} from '../../inbound-receipts/inbound-receipts-shared.schema.js';
import { IsoDateTimeSchema } from '../../shipments/shipments-types.js';

const InboundReceiptSyncPayloadBaseSchema = z
  .object({
    schemaVersion: z.literal(2),
    eventId: z.uuid(),
    occurredAt: IsoDateTimeSchema,
    companyId: z.uuid(),
    stationId: z.uuid(),
    receiptId: z.uuid(),
  })
  .strict();

export const InboundReceiptConfirmedEventPayloadSchema: z.ZodType<InboundReceiptConfirmedEventPayload> =
  InboundReceiptSyncPayloadBaseSchema.extend({
    receipt: InboundReceiptDetailDtoSchema,
  }).strict();

export const InboundReceiptCanceledEventPayloadSchema: z.ZodType<InboundReceiptCanceledEventPayload> =
  InboundReceiptSyncPayloadBaseSchema.extend({
    canceledAt: IsoDateTimeSchema,
    canceledByUserId: z.uuid(),
  }).strict();

export const InboundReceiptOfficialStateReplacedEventPayloadSchema: z.ZodType<InboundReceiptOfficialStateReplacedEventPayload> =
  InboundReceiptSyncPayloadBaseSchema.extend({
    officialSettlement: InboundReceiptOfficialSettlementDtoSchema,
    officialComparison: InboundReceiptOfficialComparisonDtoSchema,
  }).strict();

export const InboundReceiptComparisonReviewedEventPayloadSchema: z.ZodType<InboundReceiptComparisonReviewedEventPayload> =
  InboundReceiptSyncPayloadBaseSchema.extend({
    officialComparison: InboundReceiptOfficialComparisonDtoSchema,
  }).strict();

export const InboundReceiptInventoryPostedEventPayloadSchema: z.ZodType<InboundReceiptInventoryPostedEventPayload> =
  InboundReceiptSyncPayloadBaseSchema.extend({
    receipt: InboundReceiptDetailDtoSchema,
  }).strict();

export const InboundReceiptInventoryPostingReversedEventPayloadSchema: z.ZodType<InboundReceiptInventoryPostingReversedEventPayload> =
  InboundReceiptSyncPayloadBaseSchema.extend({
    receipt: InboundReceiptDetailDtoSchema,
    reason: z.string().trim().min(1).max(500).nullable().optional(),
  }).strict();
